import { render, staticRenderFns } from "./InspirationCard.vue?vue&type=template&id=1f082cf8&scoped=true&"
import script from "./InspirationCard.vue?vue&type=script&lang=js&"
export * from "./InspirationCard.vue?vue&type=script&lang=js&"
import style0 from "./InspirationCard.vue?vue&type=style&index=0&id=1f082cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f082cf8",
  null
  
)

export default component.exports